import React from 'react';
import Select, { createFilter } from 'react-select';
import { withStyles, Typography, Paper, MenuItem } from '@material-ui/core';
import { useStyles as useComponentStyles } from './style';
import { styles } from './style';

function NoOptionsMessage(props) {
    const classes = useComponentStyles();
    return (
        <Typography color="textSecondary" className={classes.noOptionsMessage} {...props.innerProps}>
            {props.children}
        </Typography>
    );
}

function Option(props) {
    const classes = useComponentStyles();
    return (
        <MenuItem
            // react-select v4/v5 uses innerRef; if you’re on v5.8+, ref also works:
            ref={props.innerRef}
            selected={props.isFocused}
            component="div"
            className={classes.option}
            {...props.innerProps}
        >
            {props.children}
        </MenuItem>
    );
}

function Placeholder(props) {
    const { children, innerProps } = props;
    const classes = useComponentStyles();
    return (
        <Typography className={classes.placeholderText} {...innerProps}>
            {children}
        </Typography>
    );
}

function Menu(props) {
    // ⭐️ Important: pass through innerProps so events/ARIA work
    const { children, innerProps } = props;
    const classes = useComponentStyles();
    return (
        <Paper
            square
            className={classes.menu}
            {...innerProps}
        >
            {children}
        </Paper>
    );
}

const components = {
    Menu,
    NoOptionsMessage,
    Option,
    Placeholder,
};

const SimpleSelect = (props) => {
    const { classes, placeholder = 'Select an option', ...rest } = props;

    return (
        <Select
            className={classes.root}
            // forward everything else (value, onChange, options, isSearchable, isClearable, id, isLoading, etc.)
            {...rest}
            placeholder={placeholder}
            components={components}
            menuPortalTarget={document.body}
            // if you portal, fixed positioning avoids scroll jank
            menuPosition="fixed"
            filterOption={createFilter({ ignoreAccents: false })}
            styles={{
                valueContainer: (base) => ({
                    ...base,
                    padding: '5px 8px 6px 8px',  // controls space for both placeholder & value
                  }),
                singleValue: (base) => ({
                    ...base,
                    fontSize: "12px",   // change font size
                    fontWeight: 400,
                    padding: '5px 8px 6px 8px',
                    fontStyle: 'normal',
                    lineHeight: '17px',
                }),
                clearIndicator: (base) => ({
                    ...base,
                    padding: "2px",
                    cursor: "pointer",
                    color: "rgba(200, 0, 0, 0.6)", // change cross color
                    ":hover": {
                        color: "red", // hover color
                    },
                    svg: {
                        width: "14px",  // resize cross icon
                        height: "14px",
                    },
                }),
                placeholder: (base) => ({
                    ...base,
                    color: '#999',
                    fontSize: '12px',
                    fontWeight: 400,
                    padding: '5px 8px 6px 8px',
                    fontStyle: 'normal',
                    lineHeight: '17px',
                }),
                control: (provided) => ({
                    ...provided,
                    minHeight: '32px',
                    height: '32px',
                    fontSize: '12px',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    lineHeight: '17px',
                    border: '1px solid rgba(213, 214, 221, 1) !important',
                    boxShadow: 'none',
                    '&:hover': {
                        border: '1px solid rgba(213, 214, 221, 1)',
                    },
                }),
                indicatorSeparator: () => ({ display: 'none' }),
                dropdownIndicator: (base) => ({
                    ...base,
                    alignSelf: 'flex-start',
                    paddingTop: '7px',
                    paddingBottom: 0,
                    color: 'rgba(95, 96, 113, 1)',
                    transform: 'translateX(-4px)',
                    svg: { width: '16px', height: '16px' },
                }),
                menu: (base) => ({
                    ...base,
                    zIndex: 99999,
                    position: 'fixed',
                }),
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                }),
                menuList: (base) => ({
                    ...base,
                    zIndex: 99999,
                }),
            }}
        />
    );
};

export default withStyles(styles, { withTheme: true })(SimpleSelect);
